import { SHARED_LOADING, SHARED_UNLOADING } from '@/store/shared.module'
import {lottoService} from "@/services/lotto.service";

//define module name
const MODULE_NAME = 'lotto/'

//define actions name
const A_LOTTO_DRAWS_CURRENT = 'drawsCurrent'
const A_LOTTO_DRAWS_RESULTS = 'drawsResults'
const A_LOTTO_WALLET_BALANCE = 'walletBalance'
const A_LOTTO_WALLET_CLAIM = 'walletClaim'
const A_LOTTO_DRAWS_LAST_HISTORY = 'drawsLastHistory'
const A_LOTTO_DRAWS_HISTORY = 'drawsHistory'
const A_LOTTO_PROGRESS = 'progress'
const A_LOTTO_TICKETS = 'tickets'
const A_LOTTO_MEMBER_PROGRESS = 'memberProgress'
const A_LOTTO_TICKETS_HISTORY = 'ticketsHistory'
const A_LOTTO_DRAWS_PAST_RESULTS = 'drawsPastResults'
const A_LOTTO_TICKETS_SETTINGS = 'drawsSettings'
const A_LOTTO_HISTORY_MATCHES = 'historyMatches'
const A_LOTTO_DRAWS_LAST_RESULTS = 'drawsLastResults'
const A_LOTTO_PAST_MATCHES = 'pastMatches'
const A_LOTTO_ACTIVITY = 'activity'

//define dispatch action
export const LOTTO_GET_DRAWS_CURRENT = MODULE_NAME + A_LOTTO_DRAWS_CURRENT
export const LOTTO_GET_DRAWS_RESULTS = MODULE_NAME + A_LOTTO_DRAWS_RESULTS
export const LOTTO_GET_WALLET_BALANCE = MODULE_NAME + A_LOTTO_WALLET_BALANCE
export const LOTTO_POST_WALLET_CLAIM = MODULE_NAME + A_LOTTO_WALLET_CLAIM
export const LOTTO_GET_DRAWS_LAST_HISTORY = MODULE_NAME + A_LOTTO_DRAWS_LAST_HISTORY
export const LOTTO_GET_DRAWS_HISTORY = MODULE_NAME + A_LOTTO_DRAWS_HISTORY
export const LOTTO_GET_PROGRESS = MODULE_NAME + A_LOTTO_PROGRESS
export const LOTTO_GET_TICKETS = MODULE_NAME + A_LOTTO_TICKETS
export const LOTTO_GET_MEMBER_PROGRESS = MODULE_NAME + A_LOTTO_MEMBER_PROGRESS
export const LOTTO_GET_TICKETS_HISTORY = MODULE_NAME + A_LOTTO_TICKETS_HISTORY
export const LOTTO_GET_DRAWS_PAST_RESULTS = MODULE_NAME + A_LOTTO_DRAWS_PAST_RESULTS
export const LOTTO_GET_TICKETS_SETTINGS = MODULE_NAME + A_LOTTO_TICKETS_SETTINGS
export const LOTTO_GET_HISTORY_MATCHES = MODULE_NAME + A_LOTTO_HISTORY_MATCHES
export const LOTTO_GET_DRAWS_LAST_RESULTS = MODULE_NAME + A_LOTTO_DRAWS_LAST_RESULTS
export const LOTTO_GET_PAST_MATCHES = MODULE_NAME + A_LOTTO_PAST_MATCHES
export const LOTTO_GET_ACTIVITY = MODULE_NAME + A_LOTTO_ACTIVITY

//define mutations name
const M_LOTTO_DRAWS_CURRENT = 'setLottoDrawsCurrent'
const M_LOTTO_DRAWS_RESULTS = 'setLottoDrawsResults'
const M_LOTTO_WALLET_BALANCE = 'setLottoWalletBalance'
const M_LOTTO_WALLET_CLAIM = 'setLottoWalletClaim'
const M_LOTTO_DRAWS_LAST_HISTORY = 'setLottoDrawsLastHistory'
const M_LOTTO_DRAWS_HISTORY = 'setLottoDrawsHistory'
const M_LOTTO_PROGRESS = 'setLottoProgress'
const M_LOTTO_TICKETS = 'setLottoTickets'
const M_LOTTO_MEMBER_PROGRESS = 'setLottoMemberProgress'
const M_LOTTO_TICKETS_HISTORY = 'setLottoTicketsHistory'
const M_LOTTO_DRAWS_PAST_RESULTS = 'setLottoDrawsPastResults'
const M_LOTTO_TICKETS_SETTINGS = 'setLottoTicketsSettings'
const M_LOTTO_HISTORY_MATCHES = 'setLottoHistoryMatches'
const M_LOTTO_DRAWS_LAST_RESULTS = 'setLottoDrawsLastResults'
const M_LOTTO_PAST_MATCHES = 'setLottoPastMatches'
const M_LOTTO_ACTIVITY = 'setLottoActivity'

//init app state
const state = {
    drawsCurrent: {},
    drawsResults: {
        data: [],
        success: false,
        complete: false,
        code: 0
    },
    walletBalance: {
        data: [],
        success: false,
        complete: false,
        code: 0
    },
    walletClaim: {},
    drawsLastHistory: {},
    drawsHistory: {},
    progress: {},
    tickets: {
        data: [],
        pagination: {}
    },
    memberProgress: {},
    ticketsHistory: {
        data: [],
        pagination: {}
    },
    drawsPastResults: {
        data: [],
        success: false,
        complete: false,
        code: 0
    },
    drawsLastResults: {
        data: [],
        success: false,
        complete: false,
        code: 0
    },
    ticketSettings: {},
    historyMatches: {},
    pastMatches: {},
    activity: {}
}

//to retrieve data from store state (called by component)
const getters = {}

//to perform some actions related with updating state (called by component)
const actions = {
    [A_LOTTO_DRAWS_CURRENT]({ commit }) {
        lottoService.lottoDrawsCurrent().then(
            data => {
                let result = data
                commit(M_LOTTO_DRAWS_CURRENT, { result })
            },
            error => {
                let result = error
                commit(M_LOTTO_DRAWS_CURRENT, { result })
            }
        )
    },
    [A_LOTTO_DRAWS_RESULTS]({ dispatch, commit }, { obj }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoDrawsResults(obj.id).then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_DRAWS_RESULTS, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_DRAWS_RESULTS, { result })
            }
        )
    },
    [A_LOTTO_WALLET_BALANCE]({ dispatch, commit }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoWalletBalance().then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_WALLET_BALANCE, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_WALLET_BALANCE, { result })
            }
        )
    },
    [A_LOTTO_WALLET_CLAIM]({ dispatch, commit }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoWalletClaim().then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_WALLET_CLAIM, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_WALLET_CLAIM, { result })
            }
        )
    },
    [A_LOTTO_DRAWS_LAST_HISTORY]({ dispatch, commit }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoLastDrawsHistory().then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_DRAWS_LAST_HISTORY, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_DRAWS_LAST_HISTORY, { result })
            }
        )
    },
    [A_LOTTO_DRAWS_HISTORY]({ dispatch, commit }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoDrawsHistory().then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_DRAWS_HISTORY, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_DRAWS_HISTORY, { result })
            }
        )
    },
    [A_LOTTO_PROGRESS]({ dispatch, commit }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoProgress().then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_PROGRESS, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_PROGRESS, { result })
            }
        )
    },
    [A_LOTTO_TICKETS]({ dispatch, commit }, { obj }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoTickets(obj).then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_TICKETS, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_TICKETS, { result })
            }
        )
    },
    [A_LOTTO_MEMBER_PROGRESS]({ dispatch, commit }, { obj }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoMemberProgress(obj).then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_MEMBER_PROGRESS, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_MEMBER_PROGRESS, { result })
            }
        )
    },
    [A_LOTTO_TICKETS_HISTORY]({ dispatch, commit }, { obj }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoTicketsHistory(obj).then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_TICKETS_HISTORY, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_TICKETS_HISTORY, { result })
            }
        )
    },
    [A_LOTTO_DRAWS_PAST_RESULTS]({ dispatch, commit }, { obj }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoDrawsResults(obj.id).then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_DRAWS_PAST_RESULTS, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_DRAWS_PAST_RESULTS, { result })
            }
        )
    },
    [A_LOTTO_TICKETS_SETTINGS]({ dispatch, commit }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoTicketSettings().then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_TICKETS_SETTINGS, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_TICKETS_SETTINGS, { result })
            }
        )
    },
    [A_LOTTO_HISTORY_MATCHES]({ dispatch, commit }, { obj }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoHistoryMatches(obj).then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_HISTORY_MATCHES, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_HISTORY_MATCHES, { result })
            }
        )
    },
    [A_LOTTO_DRAWS_LAST_RESULTS]({ dispatch, commit }, { obj }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoLastDrawsResults(obj.id).then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_DRAWS_LAST_RESULTS, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_DRAWS_LAST_RESULTS, { result })
            }
        )
    },
    [A_LOTTO_PAST_MATCHES]({ dispatch, commit }, { obj }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoPastMatches(obj).then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_PAST_MATCHES, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_PAST_MATCHES, { result })
            }
        )
    },
    [A_LOTTO_ACTIVITY]({ dispatch, commit }) {
        dispatch(`${SHARED_LOADING}`, {}, { root: true })
        lottoService.lottoActivity().then(
            data => {
                let result = data
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_ACTIVITY, { result })
            },
            error => {
                let result = error
                dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
                commit(M_LOTTO_ACTIVITY, { result })
            }
        )
    },
}

//to update state values (called by actions)
const mutations = {
    [M_LOTTO_DRAWS_CURRENT](state, { result }) {
        if (result.success) {
            state.drawsCurrent = result.data
        }
    },
    [M_LOTTO_DRAWS_RESULTS](state, { result }) {
        if (result.success) {
            state.drawsResults = {
                complete: true,
                success: true,
                data: result.data
            }
        } else {
            state.drawsResults = {
                complete: true,
                success: false,
                data: []
            }
        }
    },
    [M_LOTTO_WALLET_BALANCE](state, { result }) {
        if (result.success) {
            state.walletBalance = {
                complete: true,
                success: true,
                data: result.data
            }
        } else {
            state.walletBalance = {
                complete: true,
                success: false,
                data: []
            }
        }
    },
    [M_LOTTO_WALLET_CLAIM](state, { result }) {
        if (result.success) {
            state.walletClaim = {
                complete: true,
                success: true,
                data: result.data,
                message: result.message
            }
        } else {
            state.walletClaim = {
                complete: true,
                success: false,
                data: [],
                message: result.message,
                code: result.code
            }
        }
    },
    [M_LOTTO_DRAWS_LAST_HISTORY](state, { result }) {
        if (result.success) {
            state.drawsLastHistory = {
                complete: true,
                success: true,
                data: result.data
            }
        } else {
            state.drawsLastHistory = {
                complete: true,
                success: false,
                data: []
            }
        }
    },
    [M_LOTTO_DRAWS_HISTORY](state, { result }) {
        if (result.success) {
            state.drawsHistory = {
                complete: true,
                success: true,
                data: result.data
            }
        } else {
            state.drawsHistory = {
                complete: true,
                success: false,
                data: []
            }
        }
    },
    [M_LOTTO_PROGRESS](state, { result }) {
        if (result.success) {
            state.progress = {
                complete: true,
                success: true,
                data: result.data
            }
        } else {
            state.progress = {
                complete: true,
                success: false,
                data: []
            }
        }
    },
    [M_LOTTO_TICKETS](state, { result }) {
        if (result.success) {
            state.tickets = {
                complete: true,
                success: true,
                data: result.data,
                pagination: result.pagination
            }
        } else {
            state.tickets = {
                complete: true,
                success: false,
                data: [],
                pagination: {}
            }
        }
    },
    [M_LOTTO_MEMBER_PROGRESS](state, { result }) {
        if (result.success) {
            state.memberProgress = {
                complete: true,
                success: true,
                data: result.data
            }
        } else {
            state.memberProgress = {
                complete: true,
                success: false,
                data: []
            }
        }
    },
    [M_LOTTO_TICKETS_HISTORY](state, { result }) {
        if (result.success) {
            state.ticketsHistory = {
                complete: true,
                success: true,
                data: result.data,
                pagination: result.pagination
            }
        } else {
            state.ticketsHistory = {
                complete: true,
                success: false,
                data: [],
                pagination: {}
            }
        }
    },
    [M_LOTTO_DRAWS_PAST_RESULTS](state, { result }) {
        if (result.success) {
            state.drawsPastResults = {
                complete: true,
                success: true,
                data: result.data
            }
        } else {
            state.drawsPastResults = {
                complete: true,
                success: false,
                data: []
            }
        }
    },
    [M_LOTTO_TICKETS_SETTINGS](state, { result }) {
        if (result.success) {
            state.ticketSettings = {
                complete: true,
                success: true,
                data: result.data
            }
        } else {
            state.ticketSettings = {
                complete: true,
                success: false,
                data: []
            }
        }
    },
    [M_LOTTO_HISTORY_MATCHES](state, { result }) {
        if (result.success) {
            state.historyMatches = {
                complete: true,
                success: true,
                data: result.data
            }
        } else {
            state.historyMatches = {
                complete: true,
                success: false,
                data: []
            }
        }
    },
    [M_LOTTO_DRAWS_LAST_RESULTS](state, { result }) {
        if (result.success) {
            state.drawsLastResults = {
                complete: true,
                success: true,
                data: result.data
            }
        } else {
            state.drawsLastResults = {
                complete: true,
                success: false,
                data: []
            }
        }
    },
    [M_LOTTO_PAST_MATCHES](state, { result }) {
        if (result.success) {
            state.pastMatches = {
                complete: true,
                success: true,
                data: result.data
            }
        } else {
            state.pastMatches = {
                complete: true,
                success: false,
                data: []
            }
        }
    },
    [M_LOTTO_ACTIVITY](state, { result }) {
        if (result.success) {
            state.activity = {
                complete: true,
                success: true,
                data: result.data
            }
        } else {
            state.activity = {
                complete: true,
                success: false,
                data: []
            }
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
